import React from "react";
import '../../../App.css';

function Title() {
  return (
    <div className="title-container">
      <h2 className="title-text">Tutor Learner Database</h2>
    </div>
  );
}

export default Title;